jQuery(document).ready(function() {
	console.log("test header");
		// jQuery('.at_left img').attr("alt","Youtube");
//	jQuery('a[href="/san-bernardino-retirement-home/"]').attr('aria-label', ariaLabel);
//	jQuery('a:contains("Ask a question!")').attr('aria-label', 'Ask a question!');
//  jQuery('a .icon-yelp').parent('a').attr('aria-label', "Visit Benny's Tacos on Yelp (opens in new tab)");
     jQuery('.layout-switch--two-columns').attr('aria-label','Two column layout');
     jQuery('.layout-switch--one-column').attr('aria-label','One column layout'); 
     jQuery('.filter-shade').attr('aria-label','Open filters');
	 jQuery('.filters__close').attr('aria-label','filters close');
//   jQuery('.majortitle.in-content.h1-style').remove();

	 
	jQuery('video[playsinline="playsinline"] img').attr('alt', '');

     

     });